module.exports = __webpack_public_path__ + "static/media/hat-cowboy.89062978.svg";